import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceService } from 'src/app/services/devices/device.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
    selector: 'app-modal-scheduler-task',
    templateUrl: './modal-scheduler-task.component.html',
    styleUrls: ['./modal-scheduler-task.component.scss'],
    standalone: false
})
export class ModalSchedulerTaskComponent implements OnInit {

  @Input()
  id: number;

  @Input()
  type: number;

  @Input()
  tasks: any;

  @Input()
  weekday: any;
  @Input()
  limitP: any;

  @Input()
  task = {
    id: -1,
    user: "",
    active: 1,
    group: 0,
    type: 1,
    maxPower: 0,
    priority: 1,
    solarPriority: 0,
    initTime: {
      day: 0,
      month: 0,
      weekday: 0,
      timeList:[{
        hourMin: 0,
        duration: 0,
        maxPower: 0,
      }]
    }
  }

  initTime;
  endTime;

  successMessage=false;
  error: string = '';

  days: { [key: string]: boolean } = {
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
    sunday: true
  };

  daysOfWeek = [
    { label: 'L', value: 'monday' },
    { label: 'M', value: 'tuesday' },
    { label: 'X', value: 'wednesday' },
    { label: 'J', value: 'thursday' },
    { label: 'V', value: 'friday' },
    { label: 'S', value: 'saturday' },
    { label: 'D', value: 'sunday' }
  ];
  translate: any;

  constructor(public activeModal: NgbActiveModal, private _device: DeviceService, private _utils: UtilsService) { }

  ngOnInit(): void {
    // Check if this is a new task (id = -1) or editing existing task
    if (this.task.id === -1) {
      console.log('nueva ', this.task.id);
      // New task logic
      if (this.weekday === 0) {
        // Inicializar con todos los días seleccionados para nueva tarea
        this.days = {
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
          sunday: true
        };
        this.task.initTime.weekday = this.getWeekdayBitmask(this.days);
      } else {
        this.task.initTime.weekday = this.weekday;
        this.days = this._utils.setDaysFromBitmask(this.task.initTime.weekday);
      }
    } else {
      console.log('editar ', this.task.id);
      // Editing existing task - use task's weekday
      this.days = this._utils.setDaysFromBitmask(this.task.initTime.weekday);
    }

    this.task.type = this.type;
    if (this.task.id === -1) {
      this.task.maxPower = this.limitP || 0;
    }
    if (this.task.type == 1  && this.tasks.length == 1) {
      if (this.task.initTime.timeList[0]) {
        this.task.initTime.timeList[0].hourMin = 720;
        this.task.initTime.timeList[0].duration = 720;
      }
    }

    // Ensure we have valid time data
    const hourMin = this.task.initTime.timeList[0]?.hourMin || 0;
    const duration = this.task.initTime.timeList[0]?.duration || 0;


    console.log('Modal init - hourMin:', hourMin, 'duration:', duration, 'task:', this.task);

    this.initTime = this.getTimeFromMinutes(hourMin);

    // Special handling for end time - if it's exactly 24:00 (1440 min from start), show as 00:00
    const endTimeMinutes = hourMin + duration;
    if (endTimeMinutes === 1440) {
      this.endTime = '00:00';
    } else {
      this.endTime = this.getTimeFromMinutes(endTimeMinutes);
    }
  }

  getTimeFromMinutes(minutes){
    // Handle invalid or undefined minutes
    if (minutes === undefined || minutes === null || isNaN(minutes)) {
      minutes = 0;
    }

    // Handle 24:00 (1440 minutes) -> convert to 00:00
    if (minutes >= 1440) {
      minutes = minutes % 1440;
    }

    let h = Math.floor(minutes/60);
    let m = (minutes%60);

    // Format with leading zeros
    let hStr = h.toString().padStart(2, '0');
    let mStr = m.toString().padStart(2, '0');

    return hStr + ':' + mStr;
  }

  close(){
    this.activeModal.dismiss();
  }

  // Validate time range when user changes times
  validateTimeRange(){
    if (!this.initTime || !this.endTime) return;

    let endMinutes = this.getMinutesFromTime(this.endTime);
    let startMinutes = this.getMinutesFromTime(this.initTime);

    // Special case: if end time is 00:00, treat as 24:00 (end of day)
    if (endMinutes === 0) {
      endMinutes = 1440;
    }

    // if (endMinutes <= startMinutes) {
    //   this.error = this.translate.instant('MinimumTimeError');
    // } else {
    //   this.error = '';
    // }
  }

  saveTask(){
    // Clear any previous errors
    this.error = '';

    this.task.initTime.weekday = this.getWeekdayBitmask(this.days)

    const startMinutes = this.getMinutesFromTime(this.initTime);
    const endMinutes = this.getMinutesFromTime(this.endTime);

    this.task.initTime.timeList[0].hourMin = startMinutes;

    // Calculo modular robusto: cubre cruces de medianoche sin forzar 00:00 a 24h.
    const duration = (endMinutes - startMinutes + 1440) % 1440;
    this.task.initTime.timeList[0].duration = duration === 0 ? 1440 : duration;


    if(this.task.id==-1)
      this.task.id=this.id;
    this.task.maxPower=parseInt(this.task.maxPower.toString() || '0');
    this.task.initTime.timeList[0].maxPower=this.task.maxPower;
    if (this.task.maxPower==this.limitP) this.task.solarPriority=1;
    const taskToSave = JSON.parse(JSON.stringify(this.task));
    console.log('Save task ', taskToSave);
    this.activeModal.close(taskToSave);
  }

  getMinutesFromTime(time){
    if (!time) return 0;

    let parts = time.split(':');
    let h = parseInt(parts[0]) || 0;
    let m = parseInt(parts[1]) || 0;

    return m + (h * 60);
  }

  checkPriority(task){
    task.maxPower=parseInt(task.maxPower);
    if(task.maxPower==0) task.solarPriority=0;
    if(task.maxPower>=this.limitP) {
      task.maxPower=this.limitP;
      task.solarPriority=1
    };
    if(task.maxPower!=0 && task.solarPriority==0 || (task.maxPower<this.limitP && task.solarPriority==1)) task.solarPriority=2;
    }

  toggleDay(day: string): void {
    this.days[day] = !this.days[day];
    this.selectAll();
  }

  getWeekdayBitmask(days: any): number {
    const bitMap = {
      saturday: 6,  // S
      friday: 5,    // V
      thursday: 4,  // J
      wednesday: 3, // X
      tuesday: 2,   // M
      monday: 1,    // L
      sunday: 0     // D
    };

    let mask = 0;
    for (let day in days) {
      if (days[day]) {
        mask |= (1 << bitMap[day]);
      }
    }
    return mask;
  }


    selectAll() {
      if (Object.values(this.days).every(v => v === false)) {
        for (let day in this.days) {
          this.days[day] = true;
        }
      }
    }

}
